import { createFileRoute } from "@tanstack/react-router";
import ArticleSectionSettings from "@/pages/admin/ArticleSectionSettings";

export const Route = createFileRoute("/admin/article-section")({
  component: ArticleSectionSettings,
});
